import { useCallback, useState } from 'react';

export type UseDisclosureHandlers = {
  open: () => void;
  close: () => void;
  toggle: () => void;
  set: (value: boolean) => void;
};

export const useDisclosure = (initialState: boolean = false) => {
  const [opened, setOpened] = useState(initialState);

  const open = useCallback(() => {
    setOpened(true);
  }, []);

  const close = useCallback(() => {
    setOpened(false);
  }, []);

  const toggle = useCallback(() => {
    setOpened(prev => !prev);
  }, []);

  const set = useCallback((value: boolean) => {
    setOpened(value);
  }, []);

  const handlers: UseDisclosureHandlers = {
    open,
    close,
    toggle,
    set,
  };

  return [opened, handlers] as const;
};
